export const SOCIALS = [
  {
    id: "tiktok",
    label: "TikTok",
    handle: "@babacarbusinesscompany",
    url: "https://www.tiktok.com/@babacarbusinesscompany",
    color: "#FF3B30",
  },
  {
    id: "instagram",
    label: "Instagram",
    handle: "@negosinoservices",
    url: "https://www.instagram.com/negosinoservices",
    color: "#E1306C",
  },
  {
    id: "facebook",
    label: "Facebook",
    handle: "Negosino",
    url: "https://www.facebook.com/Negosino",
    color: "#1877F2",
  },
  {
    id: "snapchat",
    label: "Snapchat",
    handle: "negosino",
    url: "https://snapchat.com/t/ht41U6wW",
    color: "#FFFC00",
  },
];
